<template>
    <div class="card">
        <div class="card-header">
            <font-awesome-icon :icon="['fas', 'globe-americas']" class="mr-1"/>
            <!-- {{ $t('global.modules.zones') }} -->
            Regiones
            <div class="card-header-actions">
                <router-link :to="{ name: 'BusinessRegionAdd' }" v-if="showAdd">
                    <font-awesome-icon :icon="['fas', 'plus']" class="nav-icon"/>
                    {{ $t('global.buttons.add') }}
                </router-link>

                <router-link :to="{ name: 'BusinessRegionCountriesAdd' }" v-if="showAddCountry">
                    <font-awesome-icon :icon="['fas', 'plus']" class="nav-icon"/>
                    {{ $t('global.buttons.add') }}
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    computed: {
      showAdd () {
        return this.$route.meta.breadcrumb === 'Lista' && this.$ability.can('create', 'businessregion')
      },
      showAddCountry () {
        return this.$route.meta.breadcrumb === 'Lista.' && this.$ability.can('create', 'businessregion')
      }
    },
    mounted: function () {
      this.$i18n.locale = localStorage.getItem('lang')
    }
  }
</script>
